var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container-fluid px-3 px-md-0 px-lg-0 px-xl-0 video-list-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l(_vm.displayedVideoInfoList, function (videoInfo, index) {
    return _c('div', {
      key: `${videoInfo.title}_${index}`,
      staticClass: "col-md-6 col-lg-4 col-xl-4"
    }, [_c('VideoLibraryItem', {
      attrs: {
        "videoId": `${videoInfo.videoType}_${videoInfo.videoNum}`,
        "videoSrc": videoInfo.videoSrc,
        "videoType": videoInfo.videoType,
        "videoTitle": videoInfo.title,
        "videoTextDescription": videoInfo.content,
        "videoThumbnail": videoInfo.thumbnail,
        "selectedVideoPlayingId": _vm.selectedVideoPlayingId,
        "isVideoPlayerPlayer": _vm.isVideoPlayerPlayer,
        "isMP4Video": videoInfo.isMP4Player,
        "videoIdForCopyVideoSrcUrl": _vm.videoIdForCopyVideoSrcUrl,
        "tagColors": _vm.tagColors
      },
      on: {
        "receive-videoId-forCopyVideoUrl": _vm.setVideoIdForCopyVideoSourceUrl
      }
    })], 1);
  }), _vm.displayedVideoInfoList.length === 0 ? _c('div', {
    staticClass: "w-100 empty-video-list-container"
  }, [_c('span', [_vm._v("There aren't any videos available for "), _c('b', [_vm._v("\"" + _vm._s(`${_vm.videoSearchQuery}`) + "\"")])])]) : _vm._e()], 2), _vm.displayedVideoInfoList.length > 0 && _vm.totalRows > _vm.videosPerPage ? _c('div', {
    staticClass: "d-flex flex-column justify-content-center align-items-center my-4"
  }, [_c('div', {
    staticClass: "mb-3 page-number-text"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(`${_vm.cummulativeVideosDisplayed}`))]), _vm._v(" videos from "), _c('b', [_vm._v(_vm._s(`${_vm.totalRows}`))]), _vm._v(" total videos")])]), _c('b-pagination', {
    staticClass: "ml-0",
    attrs: {
      "id": "video-library",
      "total-rows": _vm.totalRows,
      "per-page": _vm.videosPerPage,
      "align": "center"
    },
    on: {
      "page-click": _vm.pageClicked
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }